import ActivityList from "./activityList";

export default ActivityList;
